export default __webpack_public_path__ + "static/media/16t.472fc52d.jpg";